<template>
  <div class="selector-labor">
   <v-dialog v-model="dialog" scrollable max-width="600px">
      <template v-slot:activator="{ on }">
          <slot v-bind:on="on">
            <v-btn color="primary" dark v-on="on">click</v-btn>
          </slot>
      </template>
      <v-card>

        <v-sheet class="pa-4 primary lighten-2" dark>

          <v-row no-gutters>
            <v-col :cols="8">
              <h3 class="d-inline">
                {{title}}

              </h3>
              </v-col>
              <v-col class="text-right">
              <v-btn text icon color="white" @click="dialog = false" small>
                <v-icon>close</v-icon>
              </v-btn>
            </v-col>
            </v-row>
            <v-row no-gutters>
            <v-col :xs="6" :sm="8">
              <v-text-field
              class="mr-1"
              v-model="search"
              label="buscar"
              prepend-inner-icon="search"
              dark
              flat
              solo-inverted
              dense
              hide-details
              clearable
              ></v-text-field>
            </v-col>
            <v-col :xs="6" :sm="4">
              <v-select
              width="100"
              v-if="groups"
              :items="groups"
              v-model="selectGroup"
              item-text="label"
              return-object
              solo-inverted
              flat
              dense
              clearable
              hide-details
              single-line
              label="Grupos"
              ></v-select>

            </v-col>
          </v-row>
        </v-sheet>




        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <v-treeview
          dense
          selectable
          hoverable
          open-on-click
          :open-all="true"
          :search="search"
          :items="itemsComputed"
          v-model="itemsSelected"
          ></v-treeview>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="save()">Cancelar</v-btn>
          <v-btn color="primary" @click="close()">Seleccionar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import _ from "lodash"

export default {
  name: "selectorLabor",
  props: ['items', 'textEmpty', 'title', 'groups'],
  data: () => ({
    dialog        : false,
    selectGroup   : null,
    search        : "",
    itemsSelected : []
  }),
  computed:{
    text(){
      return this.textEmpty;
    },
    nameGroupSelection(){
      console.dir(this.itemsSelected);
    },
    itemsComputed(){
      if(this.selectGroup){
        console.log("is grouped");
        var itemsGrouped = _.groupBy(this.items, item => {
          return _.get(item, this.selectGroup.path);
        })
        return this.getNodes(itemsGrouped)
      }else{
        console.log("is no grouped");
        return this.items;
      }
    },
  },
  created() {
    this.selectGroup = this.groups[0];
  },
  methods: {
    getNodes(items){
        return _.map(items, (item, index) => ({
          id       : index == 'undefined' ? "Sin grupo" : index,
          name     : index == 'undefined' ? "Sin grupo" : index,
          children : item // ? this.getNodes(item) : []
        }))
    },
    save(){
      this.dialog = false;
    },
    close(){
      this.dialog = false;
    }
  },
}
</script>
<style lang="scss" scoped>
.selector-labor{
  .v-dialog__container{
     display: none !important;
  }
}
</style>
